import {
    LIST_LICENCE_TYPES,
    LIST_LICENCE_TYPES_SUCCESS,
    LIST_LICENCE_TYPES_ERROR,
    ADD_LICENCE_TYPES,
    SAVE_LICENCE_TYPES,
    SAVE_LICENCE_TYPES_SUCCESS,
    SAVE_LICENCE_TYPES_ERROR,
    EDIT_LICENCE_TYPES,
    UPDATE_LICENCE_TYPES,
    UPDATE_LICENCE_TYPES_SUCCESS,
    UPDATE_LICENCE_TYPES_ERROR,
    DELETE_LICENCE_TYPES,
    DELETE_LICENCE_TYPES_SUCCESS,
    DELETE_LICENCE_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    licenceTypes: null,
    error: null,
    loading: false,
    licenceTypeSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_LICENCE_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_LICENCE_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_LICENCE_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                licenceTypes: action.payload
            }
        case SAVE_LICENCE_TYPES:
        case DELETE_LICENCE_TYPES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_LICENCE_TYPES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_LICENCE_TYPES_ERROR:
        case UPDATE_LICENCE_TYPES_ERROR:
        case DELETE_LICENCE_TYPES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_LICENCE_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                licenceTypes: [...state.licenceTypes, action.payload]
            }
        case ADD_LICENCE_TYPES:
            return {
                ...state,
                licenceTypeSelected: null,
                isEdit: false
            }
        case EDIT_LICENCE_TYPES:
            return {
                ...state,
                licenceTypeSelected: action.payload,
                isEdit: true
            }
        case UPDATE_LICENCE_TYPES_SUCCESS:
        case DELETE_LICENCE_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                licenceTypes: state.licenceTypes.map(licenceType => 
                    licenceType.id === action.payload.id ? licenceType = action.payload : licenceType
                ),
                licenceTypeSelected: null
            }
        // case DELETE_LICENCE_TYPES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         licenceTypes: state.licenceTypes.filter( licenceType => licenceType.id !== action.payload)
        //     }
        default:
            return state;
    }
}